import React, { useState } from 'react';
import axios from 'axios';
import "./JobSearch.css";

const JobSearchComponent = ({ onUpdateReplacementJobDescription }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [jobs, setJobs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    
    const handleOpen = (job) => {
      setSelectedJob(job);
      setOpen(true);
    };
    
    const handleClose = () => {
      setOpen(false);
    };

    const handleAddToJobDescription = () => {
        if (selectedJob) {
          onUpdateReplacementJobDescription(
            selectedJob.company_name,
            selectedJob.location,
            selectedJob.via,
            selectedJob.description
          );
          setOpen(false);
        }
    };

    const ResultsJobCard = ({ job, onClick }) => {
        return (
            <div className="JS-job-card" onClick={() => onClick(job)}>
                {job.thumbnail ? (
                    <img src={job.thumbnail} alt={job.title} />
                ) : (
                    <div className="company-initial">
                        {job.company_name.charAt(0)}
                    </div>
                )}
            </div>
        );
    };

    const fetchJobs = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get('/api/search-jobs', {
                params: { query: searchTerm }
            });
            setJobs(response.data.jobs_results);
            console.log(response.data.jobs_results);
        } catch (error) {
            console.error("Error fetching jobs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="JS-Container">
            <div className="JS-SearchRow">
                <input 
                    className="search-input"
                    type="text" 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)} 
                    placeholder="Search for jobs"
                />
                <button className = "jobSearchButton" onClick={fetchJobs} disabled={isLoading}>
                    {isLoading ? 'Searching...' : 'Search'}
                </button>
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <div className="jobsList">
                        {jobs.map((job, index) => (
                            <ResultsJobCard key={index} job={job} onClick={handleOpen} />
                        ))}
                    </div>
                )}
            </div>
        {open && (
        <div
            className="JS-modal-overlay"
            onClick={handleClose}
        >
            <div
            className="JS-modal-content"
            onClick={(e) => e.stopPropagation()}
            >
            {selectedJob && (
                <>
                <h2 className="JobSearchDescription">
                    {selectedJob.title}
                </h2>

                <p className="JobSearchDescription">
                    <strong>Company:</strong> {selectedJob.company_name}
                </p>

                <p className="JobSearchDescription">
                    <strong>Location:</strong> {selectedJob.location}
                </p>

                <p className="JobSearchDescription">
                    <strong>Via:</strong> {selectedJob.via}
                </p>

                <p className="JobSearchDescription">
                    <strong>Description:</strong> {selectedJob.description}
                </p>

                <div className="JS-modal-buttons">

                    <button
                    className="close_button"
                    onClick={handleClose}
                    >
                    Close
                    </button>

                    <button
                    className="add_button"
                    onClick={handleAddToJobDescription}
                    >
                    Add to Job Description
                    </button>

                </div>
                </>
            )}
            </div>
        </div>
        )}
    </div>
    );
};

export default JobSearchComponent;